/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateTag} from '../api'

export const useMutationCreateOrUpdateTag = createReactQueryMutationHook('createOrUpdateTag', createOrUpdateTag)
